import React from "react";

const DashboardPage = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <h1 className="heading1">Dashboard Page</h1>
    </div>
  );
};

export default DashboardPage;
